/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import UnidadCaja from "../UnidadCaja";
import IconTabs from "../../../../shared/iconTabs/IconTabs";
import IconTab from "../../../../shared/iconTabs/IconTab";
import InformacionRuta from "./InformacionRuta";
import InformacionOperador from "./InformacionOperador";
import TimelineRuta from "./TimelineRuta";
import Notificaciones from "./Notificaciones";
import InformacionUnidad from "./InformacionUnidad";
import { useSeguimientoMonitoreo } from "../SeguimientoMonitoreoProvider";
import useApiViajeSeguimientoMonitoreo from "../../../../api/operaciones/useApiSeguimientoMonitoreo";
import { Button } from "primereact/button";
import useApiViajeSeguimiento from "../../../../api/operaciones/useApiViajesSeguimiento";
import TerminarViajesEnRuta from "./TerminarViajesEnRuta";
import alerts from "../../../../shared/alerts";
import { updateArrayAtIndex } from "../../../../shared/arrayUtility";
import constantes from "../../../../catalogos/constantes";
import constantesOperacion from "../../../constantes";
import { programado } from "../SeguimientoMonitoreutility";
import InformacionAlarma from "./InformacionAlarma";
import YupValidator from "../../../../shared/YupValidator";
import informacionAlarma35ValidacionEsquema from "../InformacionAlarma35ValidacionEsquema";
import IncidenciaDetalle from "../../../../administracion/incidencias/incidenciaDetalle";
import { useAuth } from "../../../../Seguridad/AuthProvider";
import InformacionSeguimiento from "./InformacionSeguimiento";
import { tipoIndicador } from "../SeguimentoConstantes";
import FieldCheckBox from "../../../../shared/controls/fieldCheckBox";
import SalidasDetalle from "../../../ControlPatios/salidas/salidasDetalle";
import { Dialog } from "primereact/dialog";
import { writeToClipboard } from "../../../../shared/utility";
import { useLoadingDispatch } from "../../../../layout/show-loading-context";
import ButtonIcon from "../../../../shared/controls/ButtonIcon";
import FieldTextBox from "../../../../shared/controls/fieldTextBox";
import useSeguridad from "../../../../Seguridad/useSeguridad";
import DetalleSolicitudServicio from "../../../../taller/mantenimiento/solicitudservicio/detalleSolicitudServicio";
const InformacionViajeModal = React.memo(({ soloUnidades }) => {
  const { user: usuario } = useAuth();

  const {
    esSeguimientoMonitoreo,
    indicadoresVisibles,
    viajeSeleccionado,
    aplicarFiltro,
    ocultarViaje,
    refreshIndicadores,
  } = useSeguimientoMonitoreo();

  const api = useApiViajeSeguimientoMonitoreo();
  const apiSeguimiento = useApiViajeSeguimiento();
  const validador = new YupValidator(informacionAlarma35ValidacionEsquema);

  const [otrosViajesRuta, setOtrosViajesRuta] = useState({
    viajes: [],
    visible: false,
  });

  const [viajePorIniciar, setViajePorIniciar] = useState(null);
  const [viaje, setViaje] = useState({});
  const visible = viajeSeleccionado != null;
  const [infoRecibida, setInfoRecibida] = useState(null);
  const [erroresFormulario, setErroresFormulario] = useState({});
  const [incidenciaId, setIncidenciaId] = useState(null);
  const [paseSalidaId, setPaseSalidaId] = useState(null);
  const [, setMostrarPaseSalida] = useState(false);
  const [visibleSolciitud, setvisibleSolciitud] = useState(false);
  const [visibleSolicitudServicio, setVisibleSolicitudServicio] =
    useState(false);

  const [visibleSolicitudAtencionPatio, setVisibleSolicitudAtencionPatio] =
    useState(false);
  const [tieneViaje, setTieneViaje] = useState(false);

  const createInitialFallas = () => [{ descripcion: "" }];
  const [fallas, setFallas] = useState(createInitialFallas());
  const [EsRescate, setRescate] = useState(false);
  const [esCaja, setEsCaja] = useState(false);

  const TIPO_SERVICIO_DIESEL_ID = 2047;
  const TIPO_SERVICIO_ATENCION_PATIO_ID = 2053;
  const seguridad = useSeguridad();
  const tienePermisoRescate = seguridad.tieneAcceso(constantes.menus.Rescate);
  const dispatch = useLoadingDispatch();
  const [solicitante] = useState({
    id: usuario.empleadoId,
    nombre: usuario.nombre,
  });

  const onSavedIncidencia = useCallback(() => {
    setIncidenciaId(null);
  }, []);

  const onNuevoPaseSalida = () => {
    setPaseSalidaId(0);
    setMostrarPaseSalida(true);
  };

  const resetFallas = () => {
    setFallas(createInitialFallas());
  };
  const onNuevoRescate = () => {
    setRescate(true);
    resetFallas();
    setvisibleSolciitud(true);
  };

  const onServicios = async () => {
    const servicio = await alerts.seleccionarServicio();

    if (!servicio) {
      return;
    }

    switch (servicio) {
      case "rescate":
        onNuevoRescate();
        break;

      case "diesel":
        setVisibleSolicitudServicio(true);
        break;

      case "atencionPatio":
        setVisibleSolicitudAtencionPatio(true);
        break;

      default:
        break;
    }
  };
  const getDefaultSolicitudDiesel = () => ({
    empresaId: viaje?.empresaId ?? viajeSeleccionado?.empresaId ?? null,
    solicitante: {
      id: usuario.empleadoId,
      nombre: usuario.nombre,
    },
    unidad: {
      id: viaje?.unidad?.id ?? viajeSeleccionado?.unidadId,
      nombre:
        viaje?.unidad?.numeroEconomico ??
        viajeSeleccionado?.unidad ??
        viaje?.unidad ??
        "",
      tipoUnidad: viaje?.unidad?.tipoUnidad ?? viaje?.tipoUnidad ?? "",
    },
    cartaPorte: viajeSeleccionado?.cartaPorte ?? viaje?.cartaPorte ?? "",
    tipoServicio: {
      id: TIPO_SERVICIO_DIESEL_ID,
      nombre: "Carga de diesel",
    },
    bloquearTipoServicio: true,
    ocultarOrdenesTrabajo: true,
    comentarios: `Carga de diesel en patio

Carta Porte: ${viajeSeleccionado?.cartaPorte ?? viaje?.cartaPorte ?? ""}
Unidad: ${
      viaje?.unidad?.numeroEconomico ??
      viajeSeleccionado?.unidad ??
      viaje?.unidad ??
      ""
    }
Operador: ${viajeSeleccionado?.operador ?? ""}
Ruta: ${viajeSeleccionado?.ruta ?? ""}
Ubicación: ${viajeSeleccionado?.ubicacion ?? ""}`,
    fallas: [
      {
        numeroFalla: 1,
        descripcion: "Carga de diesel en patio",
      },
    ],
  });
  const getDefaultSolicitudAtencionPatio = () => ({
    empresaId: viaje?.empresaId ?? viajeSeleccionado?.empresaId ?? null,

    solicitante: {
      id: usuario.empleadoId,
      nombre: usuario.nombre,
    },

    unidad: {
      id: viaje?.unidad?.id ?? viajeSeleccionado?.unidadId,

      nombre:
        viaje?.unidad?.numeroEconomico ??
        viajeSeleccionado?.unidad ??
        viaje?.unidad ??
        "",

      tipoUnidad: viaje?.unidad?.tipoUnidad ?? viaje?.tipoUnidad ?? "",
    },

    patio: null,

    cartaPorte: viajeSeleccionado?.cartaPorte ?? viaje?.cartaPorte ?? "",

    tipoServicio: {
      id: TIPO_SERVICIO_ATENCION_PATIO_ID,
      nombre: "Atención en Patios",
    },

    comentarios: `Atención en Patios

Carta Porte: ${viajeSeleccionado?.cartaPorte ?? viaje?.cartaPorte ?? ""}
Unidad: ${
      viaje?.unidad?.numeroEconomico ??
      viajeSeleccionado?.unidad ??
      viaje?.unidad ??
      ""
    }
Operador: ${viajeSeleccionado?.operador ?? ""}
Ruta: ${viajeSeleccionado?.ruta ?? ""}
Ubicación: ${viajeSeleccionado?.ubicacion ?? ""}`,

    fallas: [
      {
        numeroFalla: 1,
        descripcion: "",
      },
    ],
  });
  const copiarSolicitudDiesel = (solicitud) => {
    const viajeDet = viajeSeleccionado;

    const texto = [
      "*Carga de diesel en patio*",
      `*OS:* ${solicitud?.consecutivo ?? solicitud?.id ?? ""}`,
      `*Solicitante:* ${usuario?.nombre ?? ""}`,
      "",
      `*Truck:* ${
        viaje?.unidad?.numeroEconomico ?? viajeSeleccionado?.unidad ?? ""
      }`,
      `*Driver:* ${viajeDet?.operador ?? ""}`,
      `*Carta Porte:* ${viajeDet?.cartaPorte ?? viaje?.cartaPorte ?? ""}`,
      `*Route:* ${viajeDet?.ruta ?? ""}`,
      `*Location:* ${viajeDet?.ubicacion ?? ""}`,
      "",
      "*Servicios a realizar:*",
      "1. Carga de diesel en patio",
    ].join("\n");

    writeToClipboard(texto);

    dispatch({
      type: "toast",
      message: "Se ha copiado la solicitud de diesel al portapapeles",
    });
  };
const copiarSolicitudAtencionPatio = (
  solicitudGuardada,
  solicitudEnviada,
) => {
  const viajeDet = viajeSeleccionado;

  const datosGuardados =
    solicitudGuardada?.data?.result?.entity ??
    solicitudGuardada?.data?.result ??
    solicitudGuardada?.data?.entity ??
    solicitudGuardada?.data ??
    solicitudGuardada?.result?.entity ??
    solicitudGuardada?.result ??
    solicitudGuardada?.entity ??
    solicitudGuardada ??
    {};

  const patioSeleccionado =
    datosGuardados?.patio ??
    datosGuardados?.Patio ??
    solicitudEnviada?.patio ??
    solicitudEnviada?.Patio ??
    null;

  const patioNombre =
    patioSeleccionado?.nombre ??
    patioSeleccionado?.Nombre ??
    patioSeleccionado?.label ??
    patioSeleccionado?.descripcion ??
    "Sin patio seleccionado";

  const fallasGuardadas =
    datosGuardados?.fallas?.length > 0
      ? datosGuardados.fallas
      : (solicitudEnviada?.fallas ?? []);

  const serviciosTexto = fallasGuardadas
    .filter((falla) => falla?.descripcion?.trim())
    .map(
      (falla, index) =>
        `${index + 1}. ${falla.descripcion.trim()}`,
    )
    .join("\n");

  const texto = [
    "*Atención en Patios*",

    `*OS:* ${
      datosGuardados?.codigo ??
      datosGuardados?.consecutivo ??
      datosGuardados?.id ??
      ""
    }`,

    `*Solicitante:* ${usuario?.nombre ?? ""}`,

    "",

    `*Truck:* ${
      viaje?.unidad?.numeroEconomico ??
      viajeSeleccionado?.unidad ??
      ""
    }`,

    `*Driver:* ${viajeDet?.operador ?? ""}`,

    `*Carta Porte:* ${
      viajeDet?.cartaPorte ??
      viaje?.cartaPorte ??
      ""
    }`,

    `*Route:* ${viajeDet?.ruta ?? ""}`,
    `*Location:* ${viajeDet?.ubicacion ?? ""}`,
    `*Patio:* ${patioNombre}`,

    "",

    "*Servicios a realizar:*",
    serviciosTexto || "N/A",
  ].join("\n");

  writeToClipboard(texto);

  dispatch({
    type: "toast",
    message:
      "Se ha copiado la solicitud de Atención en Patios al portapapeles",
  });
};
  const onRescate = async () => {
    const viajeDet = viajeSeleccionado;

    const posicionLatitud = esCaja
      ? (viajeDet.posicionCaja?.latitud ?? viajeDet.posicion?.latitud)
      : viajeDet.posicion?.latitud;

    const posicionLongitud = esCaja
      ? (viajeDet.posicionCaja?.longitud ?? viajeDet.posicion?.longitud)
      : viajeDet.posicion?.longitud;

    const listaFallas = (fallas ?? []).filter((f) => f.descripcion?.trim());
    const fallasTexto = listaFallas
      .map((f, i) => `${i + 1}. ${f.descripcion}`)
      .join("\n");

    const cajaDet = viaje.caja;
    let texto = "";

    texto += EsRescate ? `*Rescate* \n` : `*Atención en Patio* \n`;

    if (!esCaja && viajeDet.unidad) {
      const tipoUnidad = tiposUnidad[viaje.unidad.tipoUnidad];
      texto += `*Rescate/Servicio:* ${viaje.unidad.numeroEconomico} ${tipoUnidad} ${viaje.unidad.marca}\n`;
    } else if (esCaja && viaje.caja) {
      texto += `*Rescate/Servicio:* ${cajaDet.numeroEconomico ?? ""} ${cajaDet.marca ?? ""} \n`;
    }

    texto += `*Trailer:* ${cajaDet.numeroEconomico ?? ""} \n`;
    texto += `*Truck:* ${viaje.unidad.numeroEconomico} \n`;
    texto += `*Driver:* ${viajeDet.operador ?? ""}\n*Carta Porte:* ${
      viajeDet.cartaPorte ?? ""
    }\n`;
    texto += `*Maps:* https://www.google.com/maps?q=${
      posicionLatitud ?? ""
    },${posicionLongitud ?? ""}\n\n`;
    texto += `*Route:* ${viajeDet.ruta ?? ""}\n*Location:* ${
      viajeDet.ubicacion ?? ""
    }\n`;

    const payload = {
      fallas: listaFallas,
      unidadId: esCaja ? viajeDet.cajaId : viajeDet.unidadId,
      comentarios: texto,
      cartaPorte: viajeDet.cartaPorte,
    };

    const resp = await api.crearSolicitudRescate(viajeDet.viajeId, payload);
    const solicitud = resp?.data ?? resp;

    texto += `\n*OS:* ${
      solicitud?.consecutivo ?? solicitud?.id ?? ""
    }\n*Solicitante:* ${solicitud?.solicitante ?? ""}\n\n`;
    texto += `*Servicios a realizar:*\n${fallasTexto || "N/A"}`;

    writeToClipboard(texto);
    dispatch({
      type: "toast",
      message: "Se ha copiado la solicitud al portapapeles",
    });

    setvisibleSolciitud(false);
    resetFallas();
    onClose();
  };

  const onCancelIncidencia = useCallback(() => {
    setIncidenciaId(null);
  }, []);

  const onCancelPaseSalida = useCallback(() => {
    setPaseSalidaId(null);
  }, []);

  useEffect(() => {
    if (viajeSeleccionado != null) {
      cargarViaje().then();
    }
  }, [viajeSeleccionado]);

  const cargarViaje = async () => {
    let indicadores = [...indicadoresVisibles];

    if (esSeguimientoMonitoreo) {
      indicadores = indicadores.filter(
        (e) =>
          e !== tipoIndicador.velocidad &&
          e !== tipoIndicador.motor &&
          e !== tipoIndicador.horasManejo,
      );
    }

    const viaje = await api.getViajeById(viajeSeleccionado.viajeId, {
      posicion: viajeSeleccionado.unidad?.posicion,
      unidadId: viajeSeleccionado.unidadId,
      cajaId: viajeSeleccionado.cajaId,
      indicadores: [...indicadores],
      esSeguimientoMonitoreo,
    });

    setViaje(viaje);
    setTieneViaje(viaje && viaje.id > 0);
  };

  const recibirDatosDelHijo = (datos) => {
    setInfoRecibida(datos);
  };

  const manejarClickAlarma = async () => {
    if ((await validador.validate(infoRecibida)) === false) {
      setErroresFormulario(validador.errors);
      return;
    }

    setErroresFormulario({});

    if (infoRecibida) {
      await api.alarma(infoRecibida);
    } else {
      console.log("No hay datos disponibles.");
    }
  };

  const revisarIniciarViaje = async (viajeId, unidadId) => {
    if (!viajeId) {
      alerts.informacion("No se encontró el ID del viaje/segmento.");
      return;
    }

    if (!unidadId) {
      alerts.informacion("No se encontró la unidad del viaje/segmento.");
      return;
    }

    const listaViajesEnRuta = await apiSeguimiento.otrosViajesEnRutaPorUnidad({
      viajeId,
      unidadId,
    });

    if (listaViajesEnRuta.length === 0) {
      await iniciarViaje(viajeId);
    } else {
      setViajePorIniciar(viajeId);
      setOtrosViajesRuta({ viajes: listaViajesEnRuta, visible: true });
    }
  };

  const refresh = async () => {
    await aplicarFiltro();
    ocultarViaje();
  };

  const iniciarViaje = async (viajeId) => {
    if (!viajeId) {
      alerts.informacion("No se encontró el ID del viaje/segmento.");
      return;
    }

    await apiSeguimiento.iniciar(viajeId, { incidencias: [] });
    await refresh();
  };

  const onClose = () => {
    setOtrosViajesRuta({ viajes: [], visible: false });
  };

  const tiposUnidad = Object.fromEntries(
    Object.entries(constantes.tiposUnidad).map(([key, value]) => [value, key]),
  );

  const terminarViaje = async () => {
    const idParaTerminar = viaje?.segmentoId ?? viaje?.id;

    if (!idParaTerminar) {
      alerts.informacion(
        "No se encontró el ID del segmento/viaje para terminar.",
      );
      return;
    }

    const pregunta = !viaje?.enUltimaGeocerca
      ? "Aún no se ha detectado la llegada al destino ¿Desea terminar el viaje?"
      : "¿Desea terminar el viaje?";

    if (await alerts.preguntarSiNo(pregunta)) {
      await apiSeguimiento.terminar(idParaTerminar, {});
      await refresh();
    }
  };

  const terminarSegmento = async () => {
    const idParaTerminar = viaje?.segmentoId ?? viaje?.id;

    if (!idParaTerminar) {
      alerts.informacion("No se encontró el ID para terminar el segmento.");
      return;
    }

    if (await alerts.preguntarSiNo("¿Desea terminar el segmento?")) {
      await apiSeguimiento.terminar(idParaTerminar, {});
      await refresh();
    }
  };

  const onChangeBitacora = (bitacora) => {
    let index = viaje.ultimosIndicadores.findIndex((e) => e.id === bitacora.id);
    let viajeActual = viaje;

    if (index >= 0) {
      viajeActual.ultimosIndicadores = updateArrayAtIndex(
        viaje.ultimosIndicadores,
        index,
        bitacora,
      );
    }

    index = viajeActual.bitacora.findIndex((e) => e.id === bitacora.id);

    if (index < 0) {
      setViaje({
        ...viajeActual,
        bitacora: [bitacora, ...viajeActual.bitacora],
      });
    } else {
      setViaje({
        ...viajeActual,
        bitacora: updateArrayAtIndex(viaje.bitacora, index, bitacora),
      });
    }

    refreshIndicadores();
  };

  const solicitarDryRun = async () => {
    if (
      await alerts.preguntarSiNoAdvertencia(
        "¿Está seguro de generar el viaje como Dry Run?",
      )
    ) {
      await apiSeguimiento.solicitamosDryRun(viaje.id);
      await refresh();
    }
  };

  if (!visible) {
    return null;
  }

  const handleAlarma35Click = async (viajeId, e) => {
    const isChecked = e;
    await apiSeguimiento.actualizarAlarma35(viajeId, { alarma: isChecked });
  };

  const handleCaja = async (e) => {
    setEsCaja(e);
  };

  const renderFooterModal = () => {
    return (
      <div>
        <Button
          label="Cancelar"
          className="p-button-outlined"
          onClick={() => setvisibleSolciitud(false)}
        />
        <Button label="Guardar" autoFocus onClick={onRescate} />
      </div>
    );
  };

  return (
    <>
      <div className="seg-modal seg-modal-grande">
        <div className={"seg-dialog-header"} style={{ position: "relative" }}>
          {viaje.clienteId === constantes.cliente.Penske && (
            <div
              style={{
                position: "absolute",
                top: "8px",
                right: "45px",
                zIndex: 1,
              }}
            >
              <FieldCheckBox
                name="alarma35"
                label={
                  <span style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                    Alarma 3.5
                  </span>
                }
                colLg={8}
                value={viaje.alarma35}
                colMd={6}
                onChange={(e) => handleAlarma35Click(viaje.id, e)}
              />
            </div>
          )}

          <div className={"seg-dialog-title"}>Información del viaje</div>

          <Button
            icon="pi pi-times"
            className="p-button-rounded p-button-text seg-dialog-close"
            onClick={ocultarViaje}
          />
        </div>

        <div className="p-fluid form-value">
          <UnidadCaja viaje={viaje} />
        </div>

        <IconTabs>
          <IconTab icon={"Ruta"} tabId={0}>
            <InformacionRuta viaje={viaje} onChangeGeocerca={cargarViaje} />
          </IconTab>

          <IconTab icon={"Operador"} tabId={1}>
            <InformacionOperador viaje={viaje} />
          </IconTab>

          <IconTab icon={"Camion"} tabId={4}>
            <InformacionUnidad viaje={viaje} />
          </IconTab>

          <IconTab icon={"Posicion"} tabId={2}>
            {esSeguimientoMonitoreo ? (
              <InformacionSeguimiento
                viaje={viaje}
                onChangeBitacora={onChangeBitacora}
              />
            ) : (
              <TimelineRuta
                viajeId={viaje.id}
                bitacora={viaje.bitacora}
                onChangeBitacora={onChangeBitacora}
              />
            )}
          </IconTab>

          <IconTab icon={"Alarma"} tabId={3}>
            <Notificaciones
              viajeId={viaje.id}
              bitacora={viaje.ultimosIndicadores}
              onChangeBitacora={onChangeBitacora}
            />
          </IconTab>

          {viaje.clienteId === constantes.cliente.Penske && (
            <IconTab icon={"Alarma35"} tabId={5}>
              <InformacionAlarma
                viaje={viaje}
                enviarInfoAlPadre={recibirDatosDelHijo}
                errors={erroresFormulario}
              />
            </IconTab>
          )}
        </IconTabs>

        <div className="dialog-footer shared-buttons">
          {programado(viaje.estatus) && !soloUnidades && (
            <Button
              label="Iniciar Viaje"
              className={"p-button-sm"}
              onClick={() =>
                revisarIniciarViaje(
                  viaje.id,
                  viaje?.unidad?.id ??
                    viaje?.unidadId ??
                    viajeSeleccionado?.unidadId,
                )
              }
            />
          )}

          {viaje.puedeTerminarSegmento && !soloUnidades && (
            <Button
              label={"Terminar Segmento"}
              className={"p-button-sm"}
              onClick={terminarSegmento}
            />
          )}

          {viaje.puedeIniciarSegmento && !soloUnidades && (
            <Button
              label={"Iniciar Segmento"}
              className={"p-button-sm"}
              onClick={() =>
                revisarIniciarViaje(
                  viaje.segmentoId,
                  viaje?.segmentoUnidadId ??
                    viaje?.unidadSegmentoId ??
                    viaje?.unidad?.id ??
                    viaje?.unidadId ??
                    viajeSeleccionado?.unidadId,
                )
              }
            />
          )}

          {viaje.puedeTerminarViaje && !soloUnidades && (
            <Button
              label={"Terminar Viaje"}
              className={"p-button-sm"}
              onClick={terminarViaje}
            />
          )}

          {viaje.clienteId === constantes.cliente.Penske &&
            (viaje.estatus === constantesOperacion.estatusViajes.enRuta ||
              viaje.estatus ===
                constantesOperacion.estatusViajes.enRuta.estatusProgramado) && (
              <Button
                label={"Dry Run"}
                className={"p-button-sm"}
                onClick={solicitarDryRun}
              />
            )}

          {viaje.clienteId === constantes.cliente.Penske && (
            <Button
              label={"Alarma 3.5"}
              className={"p-button-sm"}
              onClick={manejarClickAlarma}
            />
          )}

          <Button
            label={"Reportar Incidencia"}
            className={"p-button-sm"}
            onClick={() => setIncidenciaId(0)}
          />

          {esSeguimientoMonitoreo && (
            <Button
              label={"Pase Salida"}
              className={"p-button-sm"}
              onClick={onNuevoPaseSalida}
            />
          )}

          {esSeguimientoMonitoreo && tienePermisoRescate && tieneViaje && (
            <Button
              label={"Servicios"}
              className="p-button-warning"
              onClick={onServicios}
            />
          )}
        </div>
      </div>

      <TerminarViajesEnRuta
        iniciarViaje={() => iniciarViaje(viajePorIniciar)}
        viaje={viaje}
        onClose={onClose}
        otrosViajesRuta={otrosViajesRuta}
      />

      <Dialog
        visible={paseSalidaId !== null}
        modal
        appendTo={document.body}
        baseZIndex={20000}
        style={{ width: "50vw", height: "200vh" }}
        position="right"
        onHide={() => setPaseSalidaId(null)}
      >
        <SalidasDetalle
          paseSalidaId={paseSalidaId}
          onSaved={() => setPaseSalidaId(null)}
          onCancel={onCancelPaseSalida}
          operador={viaje.operador}
          unidad={viaje.unidad}
          caja={viaje.caja}
        />
      </Dialog>
      <Dialog
        header="Atención en Patios"
        visible={visibleSolicitudAtencionPatio}
        style={{ width: "65vw" }}
        modal
        appendTo={document.body}
        onHide={() => setVisibleSolicitudAtencionPatio(false)}
      >
        <DetalleSolicitudServicio
          key="solicitud-atencion-patio"
          solicitudServicioId={0}
          defaultValues={getDefaultSolicitudAtencionPatio()}
          ocultarOrdenesTrabajo={true}
          bloquearTipoServicio={true}
          closeSolicitud={() => setVisibleSolicitudAtencionPatio(false)}
          onSave={(solicitudGuardada) => {
            copiarSolicitudAtencionPatio(solicitudGuardada);

            setVisibleSolicitudAtencionPatio(false);
          }}
        />
      </Dialog>
      <Dialog
        header="Servicio Rescate"
        visible={visibleSolciitud}
        style={{ width: "65vw" }}
        footer={renderFooterModal()}
        onHide={() => setvisibleSolciitud(false)}
      >
        <div className="me-2">
          <FieldCheckBox
            flexflow="row-reverse"
            name="esCaja"
            label="Rescate aplicado a caja"
            colLg={2}
            colMd={11}
            value={esCaja}
            onChange={handleCaja}
          />
        </div>

        <table className="taller-detalle-solicitud table table-borderless">
          <thead className="thead-light">
            <tr>
              <th style={{ width: "5%" }}>Numero</th>
              <th style={{ width: "58%" }}>Descripcion</th>
              <th className="input" style={{ width: "10%" }}>
                <ButtonIcon
                  title="Agregar Falla"
                  iconName="SiAddthis"
                  onClick={() =>
                    setFallas((prev) => [...prev, { descripcion: "" }])
                  }
                />
              </th>
            </tr>
          </thead>

          <tbody>
            {(fallas ?? []).map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>

                <td className="input">
                  <FieldTextBox
                    value={item.descripcion}
                    onChange={(value) => {
                      setFallas((prev) =>
                        prev.map((f, i) =>
                          i === index ? { ...f, descripcion: value } : f,
                        ),
                      );
                    }}
                  />
                </td>

                <td className="input">
                  <ButtonIcon
                    title="Eliminar"
                    iconName="RiDeleteBinLine"
                    onClick={() => {
                      setFallas((prev) => {
                        const nuevas = prev.filter((_, i) => i !== index);
                        return nuevas.length ? nuevas : [{ descripcion: "" }];
                      });
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Dialog>

      <Dialog
        header="Detalle Solicitud"
        visible={visibleSolicitudServicio}
        style={{ width: "65vw" }}
        modal
        appendTo={document.body}
        onHide={() => setVisibleSolicitudServicio(false)}
      >
        <DetalleSolicitudServicio
          solicitudServicioId={0}
          defaultValues={getDefaultSolicitudDiesel()}
          ocultarOrdenesTrabajo={true}
          bloquearTipoServicio={true}
          closeSolicitud={() => setVisibleSolicitudServicio(false)}
          onSave={(solicitudGuardada) => {
            copiarSolicitudDiesel(solicitudGuardada);
            setVisibleSolicitudServicio(false);
          }}
        />
      </Dialog>

      {incidenciaId != null && (
        <IncidenciaDetalle
          incidenciaId={incidenciaId}
          puedeEditar={true}
          onSaved={onSavedIncidencia}
          onCancel={onCancelIncidencia}
          empleado={solicitante}
          viaje={viaje}
          esSeguimientoMonitoreo={esSeguimientoMonitoreo}
        />
      )}
    </>
  );
});

export default InformacionViajeModal;
